import React from 'react';

const LoadingSpinner = ({ fullScreen = false }) => {
  const spinner = (
    <div className="flex flex-col items-center justify-center">
      <div className="relative">
        <div className="w-16 h-16 border-4 border-nebula-purple/30 rounded-full"></div>
        <div className="absolute top-0 left-0 w-16 h-16 border-4 border-nebula-purple border-t-transparent rounded-full animate-spin"></div>
      </div>
      <p className="mt-4 text-gray-400">Загрузка...</p>
    </div>
  );

  if (fullScreen) {
    return (
      <div className="fixed inset-0 bg-space-deep/90 backdrop-blur-sm z-50 flex items-center justify-center">
        {spinner}
      </div>
    );
  }

  return spinner;
};

export default LoadingSpinner;